import { styled } from '@mui/system'
import Icon from '../../atoms/icon'
import { ScrollbarStyled } from '../../particles/slider/slider.styled'

const shouldForwardProp = (prop) =>
	!['action', 'controlsPosition', 'pagination', 'navigation', 'titleComponent', 'scrollbar'].includes(prop)

const Root = styled('div', { shouldForwardProp })`
	${({ theme }) => theme.breakpoints.up('sm')} {
		${({ controlsPosition, navigation }) =>
			controlsPosition === 'default' && navigation
				? `
						& > div > div:not(.swiper-pagination) {
							padding-left: calc(var(--swiper-navigation-size) + 4.8%);
							padding-right: calc(var(--swiper-navigation-size) + 4.8%);
						}
				  `
				: `
						--swiper-navigation-size: 48px;
				  `}
		${({ controlsPosition, scrollbar, navigation }) =>
			controlsPosition === 'default' && scrollbar
				? navigation
					? `--swiper-scrollbar-bottom: -30px; --swiper-scrollbar-sides-offset: calc(var(--swiper-navigation-size) + 4.8%);`
					: `--swiper-scrollbar-bottom: -30px;`
				: null}
	}

	.swiper-pagination {
		padding: 20px 16px 20px;
		display: block;
		${({ theme }) => theme.breakpoints.up('sm')} {
			padding: ${({ controlsPosition, theme }) =>
				controlsPosition === 'default' ? 'var(--spacing-4)' : theme.spacing(0, 2)};
		}
		position: static;
		left: 0;
		transform: none;
	}
`

const TopContainer = styled('div', { shouldForwardProp })`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: ${({ titleComponent }) => (titleComponent ? 'space-between' : 'center')};
	padding-bottom: 3.85%;
	${({ theme }) => theme.breakpoints.up('sm')} {
		flex-direction: row;
	}
`

const ControlsContainer = styled('div')`
	align-items: center;
	display: flex;
	justify-content: center;
	width: 100%;
	line-height: 0;
	${({ theme }) => theme.breakpoints.up('sm')} {
		justify-content: flex-end;
		width: auto;
	}
	.swiper-button-prev,
	.swiper-button-next {
		position: static;
	}
`

const NavButton = styled(Icon, { shouldForwardProp })`
	&.swiper-button-prev,
	&.swiper-button-next {
		border: 1px solid ${({ theme }) => theme.palette.grey.light};
		border-radius: 50%;
		color: ${({ theme }) => theme.palette.primary.main};
		font-size: ${({ theme }) => theme.typography.pxToRem(48)};
		padding: 13px;
	}
	${({ controlsPosition }) =>
		controlsPosition === 'top-right'
			? `
			margin-top: 0;
		`
			: null}
	${({ action, pagination, theme }) =>
		!pagination
			? action === 'prev'
				? `
						margin-right: ${theme.spacing(1.5)};
				  `
				: `
						margin-left: ${theme.spacing(1.5)};
				  `
			: null}
`

const Pagination = styled('div', { shouldForwardProp })`
	padding: ${({ controlsPosition, theme }) =>
		controlsPosition === 'default' ? 'calc(' + theme.spacing(0.5) + ' + 3.3%) 0 0' : theme.spacing(0, 2)};
	position: static;
	.swiper-pagination-bullet {
		background-color: transparent;
		height: auto;
		margin: 0 4px;
		opacity: 1;
		padding: ${({ theme }) => theme.spacing(0.5)};
		width: auto;
		&:before {
			background-color: ${({ theme }) => theme.palette.grey.light};
			border-radius: 50%;
			content: '';
			display: block;
			height: 8px;
			width: 8px;
		}
		&-active {
			cursor: default;
			:before {
				background-color: ${({ theme }) => theme.palette.grey.main};
			}
		}
	}
`

const Scrollbar = styled(ScrollbarStyled, { shouldForwardProp })`
	&.swiper-scrollbar {
		position: static;
		min-width: 200px;
	}
`

export { ControlsContainer, NavButton, Pagination, Root, TopContainer, Scrollbar }
